// fr_pms_manager_dashboard.ts
// Tłumaczenia dla ekranu Manager Dashboard (ManagerDashboard.tsx)
// Statusy pokoi, akcje, common labels → importuj z fr_pms_common.ts

export const frPmsManagerDashboard = {

  // ── Tytuły modali szczegółów ──────────────────────────────────────────────
  detailTitles: {
    rooms:    { title: "Chambres et etat du stock",        sub: "Statut des chambres en direct sur tous les etages" },
    guest:    { title: "Experience client",              sub: "Satisfaction, avis et service recovery (90 derniers jours)" },
    dept:     { title: "Apercu des departements",                 sub: "Statut, charge et exceptions par departement (aujourd'hui)" },
    segments: { title: "Segments de demande principaux",   sub: "Nuits-chambres et revenu par segment (28 derniers jours)" },
    market:   { title: "Marche et rythme",                    sub: "Benchmark par rapport au comp set" },
    labor:    { title: "Apercu du personnel",            sub: "Effectifs et couts par departement (aujourd'hui)" },
    risk:     { title: "File des risques operationnels",       sub: "Risques actifs necessitant une attention" },
  },

  // ── Pasek KPI ─────────────────────────────────────────────────────────────
  kpi: {
    occupancy:        "Occupation",
    adr:              "ADR",
    revpar:           "RevPAR",
    revenueToday:     "Revenu aujourd'hui",
    forecastPickup:   "Pickup previsionnel",
    guestSatisfaction:"Satisfaction clients",
    openIssues:       "Problemes ouverts",
    laborCoverage:    "Couverture du personnel",
    onTheBooks:       "On the books",
    onTarget:         "Dans la cible",
    belowPlan:        "Sous le plan",
    vsLY:             "vs UB",       // vs Ubiegły Rok
    vsFCST:           "vs PROG",     // vs Prognoza
  },

  // ── Sekcja wykres / Performance & Forecast ────────────────────────────────
  performanceForecast: {
    title:           "Performance et prevision",
    legendRevenue:   "Revenu ($)",
    legendOccupancy: "Occupation (%)",
    revenueToday:    "Revenu aujourd'hui",
    revenueForecast: "Prevision de revenu",
    next7Days:       "7 prochains jours",
  },

  // ── Pokoje i inwentarz ────────────────────────────────────────────────────
  rooms: {
    title:                  "Chambres et etat du stock",
    viewDetails:            "Voir les details",
    sellableInventory:      "Stock vendable",
    housekeepingReadiness:  "Preparation housekeeping",
    outOfOrder:             "Hors service",
    blockedRooms:           "Chambres bloquees",
    maintenanceImpact:      "Impact maintenance",
    blockedForRevenue:      "Bloque pour le revenu",
    noImpact:               "Aucun impact",
    arrivalRoomsNotReady:   "Chambres d'arrivee non pretes",
    highPriority:           "Priorite elevee",
    allClear:               "Tout est pret",
    // Szczegóły modalu
    totalRooms:             "Toutes les chambres",
    sellable:               "Vendables",
    occupied:               "Occupees",
    available:              "Disponibles",
    dirtyBlocked:           "Sales / bloquees",
    byFloor:                "Par etage",
    tableHeaders:           ["Etage", "Total", "Occupees", "Disponibles", "Sales", "Reservees", "H.S."],
    floorLabel:             "Etage",
    reservedForArrivals:    "reservees pour les arrivees a venir",
    room:                   "chambre",
    rooms:                  "chambres",
    ofTotal:                "% du total",
    ofOccupancy:            "% d'occupation",
  },

  // ── Doświadczenie gości ───────────────────────────────────────────────────
  guest: {
    title:             "Pulse de l'experience client",
    viewDetails:       "Voir les details",
    satisfactionScore: "Score de satisfaction",
    activeComplaints:  "Plaintes actives",
    vipArrivalsToday:  "Arrivees VIP aujourd'hui",
    vipInHouse:        "in-house",
    highPriority:      "Priorite elevee",
    noneOpen:          "Aucun ouvert",
    serviceRecovery:   "Service recovery",
    openCases:         "Dossiers ouverts",
    reviewSentiment:   "Sentiment des avis",
    noReviewsYet:      "Aucun avis",
    responseSLA:       "SLA de reponse",
    onTarget:          "Dans la cible",
    belowTarget:       "Sous la cible",
    noData:            "Aucune donnee",
    noGuestData:       "Aucune donnee sur l'experience client.",
    positiveReviews:   "% positifs",
    reviews:           "avis",
    // Szczegóły modalu – tabela
    detailLabels: {
      satisfaction:    "Satisfaction",
      reviews90d:      "Avis (90j)",
      responseSLA:     "SLA de reponse",
      complaints:      "Plaintes actives",
      serviceRecovery: "Service recovery",
      openCasesLabel:  "dossiers ouverts",
      vipTodayInHouse: "VIP aujourd'hui / in-house",
    },
    sentiment: {
      label:    "Sentiment des avis",
      positive: "Positif",
      neutral:  "Neutre",
      negative: "Negatif",
    },
  },

  // ── Przegląd działów ─────────────────────────────────────────────────────
  dept: {
    title:        "Apercu des departements",
    viewAll:      "Tout voir",
    noData:       "Aucune donnee de personnel pour aujourd'hui.",
    loading:      "Chargement...",
    atRisk:       "A risque",
    onTrack:      "Sur la bonne voie",
    tableHeaders: ["Departement", "Statut", "Charge", "Exc.", "Responsable"],
    detailHeaders:["Departement", "Responsable", "Statut", "Charge", "Plan", "Req.", "Couverture", "Exc."],
  },

  // ── Segmenty popytu ───────────────────────────────────────────────────────
  segments: {
    title:        "Segments de demande principaux",
    stayDate:     "Date de sejour",
    viewAll:      "Tout voir",
    noData:       "Aucun sejour au cours des 28 derniers jours.",
    loading:      "Chargement...",
    other:        "Autres",
    total:        "Total",
    tableHeaders: ["Segment", "Chambres", "% du total", "ADR", "RevPAR"],
    detailHeaders:["Segment", "Nuits-chambres", "% de part", "Revenu", "ADR", "RevPAR"],
  },

  // ── Rynek i tempo ─────────────────────────────────────────────────────────
  market: {
    title:            "Marche et rythme",
    viewAll:          "Tout voir",
    noData:           "Aucune donnee de marche.",
    asOf:             "Au",
    marketOccupancy:  "Occupation marche",
    marketADR:        "ADR marche",
    marketRevPAR:     "RevPAR marche",
    compSetIndex:     "Indice comp set",
    aboveCompSet:     "Au-dessus du comp set",
    belowCompSet:     "En dessous du comp set",
    paceToForecast:   "Rythme vers prevision",
    revenueForecast7d:"Prevision de revenu (7j)",
    vs28dAgo:         "vs il y a 28 jours",
    onPace:           "Dans le rythme",
    behindPace:       "En retard",
    noForecast:       "Aucune prevision",
    description:      "Les ecarts comparent le benchmark actuel au meme indicateur d'il y a 28 jours. Un indice comp set superieur a 100 signifie que l'etablissement surperforme la concurrence.",
  },

  // ── Przegląd zatrudnienia ─────────────────────────────────────────────────
  labor: {
    title:         "Apercu du personnel",
    viewAll:       "Tout voir",
    noData:        "Aucune donnee de personnel.",
    coverage:      "Couverture",
    scheduled:     "Planifie",
    totalCost:     "Cout total de la main-d'oeuvre",
    vsRequired:    "vs requis",
    required:      "requis",
    byDept:        "Par departement",
    noPerDept:     "Aucune donnee par departement.",
    onTarget:      "Dans la cible",
    belowPlan:     "Sous le plan",
    noDataShort:   "Aucune donnee",
    revenueOf:     "% du revenu",
    staffingGap:   "Manque de personnel",
    fullyCovered:  "Couverture totale",
    tableHeaders:  ["Departement", "Plan", "Requis", "Couverture", "Responsable"],
  },

  // ── Brief kierowniczy ─────────────────────────────────────────────────────
  leadershipBrief: {
    title:                   "Brief direction",
    todaySummary:            "Resume du jour",
    upcomingHighlights:      "Points forts a venir",
    notes:                   "Notes",
    noActiveNotes:           "Aucune note active. Ajoutez-en une depuis le Live Board.",
    noUpcomingGroupBlocks:   "Aucun bloc groupe a venir",
    pickupVsYesterday:       "Pickup vs hier",
    revenuePace:             "Rythme du revenu",
    compSetIndex:            "Comp Set Index",
    displacement:            "Deplacement",
    today:                   "aujourd'hui",
    groupPrefix:             "Groupe : ",
    noReleaseDate:           "Aucune date de release",
    rooms:                   "chambres",
    room:                    "chambre",
    pickupOf:                "pickup",
  },

  // ── Kolejka ryzyk ─────────────────────────────────────────────────────────
  risk: {
    title:    "File des risques operationnels",
    viewAll:  "Tout voir",
    noRisks:  "Aucun risque operationnel actif",
    loading:  "Chargement...",
  },

} as const;

export default frPmsManagerDashboard;
